import { StyleSheet } from 'react-native';
import { grid } from '@shared/styles';

export const multiSelectUserRowStyles = StyleSheet.create({
  userImage: {
    width: grid(5),
    height: grid(5),
    borderRadius: grid(2.5),
    overflow: 'hidden',
    marginRight: grid(2),
  },
});
